<template>
  <div class="settings-group">
    <div v-if="title || description">
      <div v-if="title" class="text-h5 mb-2">{{ title }}</div>
      <div v-if="description" class="description grey--text">
        {{ description }}
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'SettingsGroup',
  props: {
    title: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.settings-group {
  display: grid;
  gap: 22px;

  .description {
    max-width: 400px;
  }
}
</style>
